

 const BaseURL='https://route-ecommerce.onrender.com/api/v1/';

 export default BaseURL;